export default __webpack_public_path__ + "static/media/bush_.50329454.png";